module.exports = __webpack_public_path__ + "img/coursebasics2.4587c4fc.jpg";